import {useState,useCallback,useEffect} from 'react'
import {rt} from '../helpers/firebase'
import {ref,onValue,push,update,remove,query,orderByChild,limitToLast} from 'firebase/database'

export default function useNotifications(uid) {
    const [notifications,setNotifications]=useState([])
    const [unreadCount,setUnreadCount]=useState(0)

    useEffect(()=>{
        if(!uid) return
        const notifRef=query(ref(rt,`notifications/${uid}`),orderByChild('createdAt'),limitToLast(50))
        const unsub=onValue(notifRef,snap=>{
            if(!snap.exists()){setNotifications([]);setUnreadCount(0);return}
            const data=snap.val()
            const list=Object.entries(data)
                .map(([id,n])=>({id,...n}))
                .sort((a,b)=>b.createdAt-a.createdAt)
            setNotifications(list)
            setUnreadCount(list.filter(n=>!n.read).length)
        })
        return unsub
    },[uid])

    const markRead=useCallback(async (notifId)=>{
        if(!uid) return
        await update(ref(rt,`notifications/${uid}/${notifId}`),{read: true})
    },[uid])

    const markAllRead=useCallback(async ()=>{
        if(!uid||!notifications.length) return
        const updates={}
        notifications.filter(n=>!n.read).forEach(n=>{updates[`notifications/${uid}/${n.id}/read`]=true})
        if(Object.keys(updates).length>0) await update(ref(rt),updates)
    },[uid,notifications])

    const deleteNotif=useCallback(async (notifId)=>{
        if(!uid) return
        await remove(ref(rt,`notifications/${uid}/${notifId}`))
    },[uid])

    return {notifications,unreadCount,markRead,markAllRead,deleteNotif}
}

/** Server-side helper: push a notification to a user's RTDB node */
// Usage: await pushNotification(rt, targetUid, {type, title, body, link})
export function pushNotification(rtInstance,targetUid,{type='info',title,body,link=null}) {
    const notifRef=ref(rtInstance,`notifications/${targetUid}`)
    return push(notifRef,{type,title,body,link,read: false,createdAt: Date.now()})
}
